import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    userInfo: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    userAvatar: {
        marginRight: theme.spacing()
    }
});

export type Classes = WithStyles<typeof styles>
